import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Map } from 'immutable';
import { map, Observable } from 'rxjs';

import { GroupingTagItemEntity } from '../domain/grouping-tag-item.entity';
import { featureSelector, GroupingTagRootState } from './feature.store';
import {
	GroupingTagMainSliceState,
	GroupingTagSliceKey,
} from './grouping-tag.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[GroupingTagSliceKey]
);

const availableGroupingTags = createSelector(
	baseSelector,
	(state) => state.groupingTags
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const selectGroupingTagById = (id: string) =>
	createSelector(
		availableGroupingTags,
		(groupingTags) => groupingTags.get(id) as GroupingTagItemEntity
	);

@Injectable()
export class GroupingTagSelector {
	public constructor(private readonly store: Store<GroupingTagRootState>) {}

	private get state(): Observable<GroupingTagMainSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getGroupingTagItems$(): Observable<
		Map<string, GroupingTagItemEntity>
	> {
		return this.store.pipe(select(availableGroupingTags));
	}

	public getGroupingTagTotalCount$(): Observable<number> {
		return this.state.pipe(map((state) => state.get('totalItems')));
	}

	public getProjectsByGroupingTagId$(
		id: string
	): Observable<GroupingTagItemEntity> {
		return this.store.pipe(select(selectGroupingTagById(id)));
	}
}
